import React, { useMemo, useState } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

const CuisineMasterSelector = ({
  cuisines,
  value,
  onChange,
  loading,
  error,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState("");
  const selectedCuisine = useMemo(
    () => cuisines.find((cuisine) => cuisine.id === Number(value)) || null,
    [cuisines, value]
  );

  return (
    <Autocomplete
      options={cuisines}
      value={selectedCuisine}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      onChange={(_, cuisine) => onChange(cuisine?.id ?? null)}
      getOptionLabel={(cuisine) => cuisine.name}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      filterOptions={(options, state) => {
        const query = state.inputValue.trim().toLocaleLowerCase();
        if (!query) return options;
        return options.filter((option) =>
          `${option.name} ${option.description}`.toLocaleLowerCase().includes(query)
        );
      }}
      loading={loading}
      disabled={disabled}
      clearOnEscape
      noOptionsText={
        loading
          ? "Loading cuisines..."
          : error
            ? "Unable to load cuisines"
            : inputValue.trim()
              ? "No matching cuisines"
              : "No cuisines available"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select cuisine (optional)"
          error={Boolean(error)}
          helperText={error || (loading ? "Loading cuisines..." : " ")}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default CuisineMasterSelector;
